/** The page to show when the list may have shrunk under it (filters, deletes). */
export function clampPage(page: number, pageSize: number, total: number): number {
  return Math.min(page, Math.max(0, Math.ceil(total / pageSize) - 1));
}
